module.exports = __webpack_public_path__ + "images/花筑pr长图_06-3.jpg?v=f516b84a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_06-3.jpg
 ** module id = 23
 ** module chunks = 1 2
 **/